<template>
  <div class="vx-card mol-card-interaction" @click="jumpToAnchor(anchor)">
    <vs-row class="card-content">
      <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="12">
        <span class="aisea-text-16-600-white truncate">
          {{ vesselName }}
        </span>
      </vs-col>
    </vs-row>
    <ul>
      <li>
        <vs-row class="aisea-mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 投錨登録 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ dataSource }}
            </span>
          </vs-col>
        </vs-row>
      </li>
      <li>
        <vs-row class="aisea-mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 投錨完了日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ completedAnchor }}
            </span>
          </vs-col>
        </vs-row>
      </li>
      <li>
        <vs-row class="aisea-mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 船速 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ speed }}kn
            </span>
          </vs-col>
        </vs-row>
      </li>
      <li>
        <vs-row class="aisea-mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 更新日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ updateDate }}
            </span>
          </vs-col>
        </vs-row>
      </li>
    </ul>
    <vs-button
      class="delete-button"
      :color="AISEA_COLOR.BLUE"
      type="border"
      size="small"
      icon-pack="feather"
      icon="icon-trash-2"
      @click.stop="deleteAnchorConfirm(anchor.vessel_id)"
      >削除</vs-button
    >
  </div>
</template>

<script>
/**
 * アンカー船一つを描画するコンポーネント
 * @parent O.AnchorVessel
 * @props anchor: アンカー船の詳細データの一つ
 * @props jumpToAnchor: 拠点選択時にvuexの追跡情報とFireStoreの追跡情報を更新しする関数
 * @props deleteAnchorConfirm: 選択したアンカーをFireStoreから削除するための確認ダイアログを表示
 */
import { ColorMixin } from "@/mixins";
import * as Enum from "@/config/const.js";
import moment from "moment-timezone";

export default {
  mixins: [ColorMixin],
  name: "M.AncharVesselCard",
  props: {
    anchor: {
      type: Object,
    },
    jumpToAnchor: {
      type: Function,
    },
    deleteAnchorConfirm: {
      type: Function,
    },
  },
  data() {
    return {
      defaultValues: {
        noneDate: "---",
        noneText: "",
        noneStatus: "-",
        noneNumber: "0",
      },
    };
  },
  computed: {
    // 船名
    vesselName() {
      if (!this.anchor) return this.defaultValues.noneText;
      return this.anchor.vesselName || this.defaultValues.noneText;
    },
    // データソース
    dataSource() {
      if (this.anchor && this.anchor.data_source_id) {
        switch (this.anchor.data_source_id) {
          case Enum.ANCHOR_VESSEL_DATA_SOURCE.AISEA.id: {
            return Enum.ANCHOR_VESSEL_DATA_SOURCE.AISEA.name;
          }
          case Enum.ANCHOR_VESSEL_DATA_SOURCE.KEISOKU.id: {
            return Enum.ANCHOR_VESSEL_DATA_SOURCE.KEISOKU.name;
          }
          default: {
            return this.defaultValues.noneText;
          }
        }
      } else {
        return this.defaultValues.noneText;
      }
    },
    // 投錨完了日時
    completedAnchor() {
      if (this.anchor && this.anchor.completed_at) {
        return this.anchor.completed_at.seconds
          ? moment(this.anchor.completed_at.seconds * 1000).format(
              "YYYY/MM/DD HH:mm",
            )
          : this.defaultValues.noneDate;
      } else {
        return this.defaultValues.noneDate;
      }
    },
    // 船速
    speed() {
      if (!this.anchor) return this.defaultValues.noneNumber;
      if (!this.anchor.vesselPosition) return this.defaultValues.noneNumber;
      return this.anchor.vesselPosition.v != null
        ? this.anchor.vesselPosition.v
        : this.defaultValues.noneNumber;
    },
    // 更新日時
    updateDate() {
      if (this.anchor && this.anchor.updated_at) {
        return this.anchor.updated_at.seconds
          ? moment(this.anchor.updated_at.seconds * 1000).format(
              "YYYY/MM/DD HH:mm",
            )
          : this.defaultValues.noneDate;
      } else {
        return this.defaultValues.noneDate;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.vx-card {
  position: relative;
  background: $aisea-blue-gray;
  cursor: pointer;
  width: 360px;
  height: 179px;
  padding: 16px;
  margin: 0 auto;

  .delete-button {
    position: absolute;
    height: 32px;
    bottom: 12px;
    right: 12px;
    font-size: 14px;
  }

  .card-content {
    margin-bottom: 7px;
  }
}

.mol-card-interaction {
  background-color: $aisea-blue-gray;
  &:hover {
    background-color: #6a717d;
  }
  &:active {
    background-color: #969ba4;
  }
}
</style>
